import { createStore, Provider } from 'jotai'
import type { PropsWithChildren } from 'react'

export const store = createStore()

export function StoreProvider({ children }: PropsWithChildren) {
  return <Provider store={store}>{children}</Provider>
}
